import PropTypes from "prop-types"
import React from "react"

import Badge from "src/components/Badge"
import { statusToken } from "src/components/Badge/status_tokens"

const PublicationStatusBadge = ({ publicationStatus }) => {
  const text = publicationStatus ? "Published" : "Unpublished"

  return <Badge color={statusToken(text)} text={text} />
}

PublicationStatusBadge.propTypes = {
  publicationStatus: PropTypes.bool.isRequired,
}

export default PublicationStatusBadge
